import { useTranslation } from 'react-i18next'
const options=[{code:'pt',label:'Português'},{code:'en',label:'English'},{code:'es',label:'Español'},{code:'fr',label:'Français'},{code:'it',label:'Italiano'}]
export default function LanguageSwitcher(){
  const { i18n } = useTranslation()
  return <select className="input !py-1 !px-2 !h-8 w-[150px]" value={i18n.language?.slice(0,2) ?? 'pt'} onChange={e=>{const l=e.target.value;i18n.changeLanguage(l);localStorage.setItem('lang',l)}}>
    {options.map(o=> <option key={o.code} value={o.code}>{o.label}</option>)}
  </select>
}
